export default __webpack_public_path__ + "static/HiVPN-ffbd2647486967acd26f34caf91749fc.png";